module.exports = __webpack_public_path__ + "static/media/kudos-like-active.f3cdc013.svg";